import * as yup from 'yup';

export const householdExpenditureSchema = yup.object().shape({
  childSpousalMaintenance: yup
    .number()
    .typeError('Child and Spousal Maintenance must be a number')
    .required('Child and Spousal Maintenance is required'),

  childcare: yup
    .number()
    .typeError('Childcare must be a number')
    .required('Childcare is required'),

  clothingPersonalCare: yup
    .number()
    .typeError('Clothing and Personal Care must be a number')
    .required('Clothing and Personal Care is required'),

  basicInsurances: yup
    .number()
    .typeError('General Basic Insurances must be a number')
    .required('General Basic Insurances is required'),

  groceries: yup
    .number()
    .typeError('Groceries must be a number')
    .required('Groceries is required'),

  healthInsurance: yup
    .number()
    .typeError('Health Insurance must be a number')
    .required('Health Insurance is required'),

  educationFees: yup
    .number()
    .typeError('Higher Education & Fees must be a number')
    .required(
      'Higher Education, Vocational Training and Professional Fees is required',
    ),

  medicalHealth: yup
    .number()
    .typeError('Medical and Health must be a number')
    .required('Medical and Health is required'),

  petCare: yup
    .number()
    .typeError('Pet Care must be a number')
    .required('Pet Care is required'),

  residenceCosts: yup
    .number()
    .typeError('Primary Residence Running Costs must be a number')
    .required('Primary Residence Running Costs is required'),

  privateSchooling: yup
    .number()
    .typeError('Private Schooling must be a number')
    .required('Private Schooling and Tuition is required'),

  publicEducation: yup
    .number()
    .typeError('Public Education must be a number')
    .required(
      'Public or Government Primary and Secondary Education is required',
    ),

  recreationEntertainment: yup
    .number()
    .typeError('Recreation and Entertainment must be a number')
    .required('Recreation and Entertainment is required'),

  insuranceLifeAccident: yup
    .number()
    .typeError('Insurance must be a number')
    .required(
      'Sickness and Personal Accident Insurance, Life Insurance is required',
    ),

  mediaSubscriptions: yup
    .number()
    .typeError('Media Subscriptions must be a number')
    .required(
      'Telephone, Internet, PayTV and Media Streaming Subscriptions is required',
    ),

  transport: yup
    .number()
    .typeError('Transport must be a number')
    .required('Transport is required'),
});
